import React, { useEffect } from "react";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";
import RegistrationOrgForm from "./RegistrationOrgForm";
import XdrSetting from "../XdrSetting";

const RegistrationOrg = () => {
  useEffect(() => {
    const body = document.querySelector("#CreateOrgTop");

    body.scrollIntoView(
      {
        behavior: "smooth",
      },
      500
    );
  }, []);
  return (
    <Layout>
      <HeaderOrg />
      <section className="layout-container">
        <div className="container" id="CreateOrgTop">
          <div className="descript-container container-2">
            <div className="form-title g-clr">Registration</div>
            If you have an NPI (National Provider Identifier) number, enter the
            10-digit identification number. Otherwise, fill in the information
            below, selecting the organization's specialty, how emails will be
            delivered, and the types of services enabled for this organization.
          </div>
          <RegistrationOrgForm />
        </div>
      </section>
      <XdrSetting />
    </Layout>
  );
};

export default RegistrationOrg;
